<template lang="html">
    <div>
        <app-header></app-header>
        <app-feature></app-feature>
        <app-project></app-project>
        <app-skill></app-skill>
        <app-testimonial></app-testimonial>
        <app-companies></app-companies>
        <app-schedule></app-schedule>
        <app-contact></app-contact>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from './sections/Header.vue';
import Features from './sections/Features.vue';
import Projects from './sections/Projects.vue';
import Testimonials from './sections/Testimonials.vue';
import Skills from './sections/Skills.vue';
import Companies from './sections/Companies.vue';
import Schedules from './sections/Schedules.vue';
import Contact from './sections/Contact.vue';
import Footer from './sections/Footer.vue';

export default {
  components: {
    appHeader: Header,
    appFeature: Features,
    appProject: Projects,
    appTestimonial: Testimonials,
    appSkill: Skills,
    appCompanies: Companies,
    appSchedule: Schedules,
    appContact: Contact,
    appFooter: Footer
  }
}
</script>

<style lang="scss">

    
</style>



// WEBPACK FOOTER //
// Home.vue?5a73da48